import React from 'react';

interface SectionCardProps {
    title: React.ReactNode;
    /** 卡头右侧内容（说明文字 / 按钮） */
    extra?: React.ReactNode;
    className?: string;
    bodyClassName?: string;
    children: React.ReactNode;
}

/** 原型 .card：1px #EFEFEF 边、圆角 10px、卡头 16×22 内边距、标题 17px、卡体 18×22 */
const SectionCard: React.FC<SectionCardProps> = ({ title, extra, className, bodyClassName, children }) => (
    <div className={`bg-white border border-[#EFEFEF] rounded-[10px] mb-[18px] ${className ?? ''}`.trim()}>
        <div className="flex justify-between items-center px-[22px] py-4 border-b border-[#EFEFEF]">
            <h3 className="m-0 text-[17px] font-semibold text-[#1F1F1F]">{title}</h3>
            {extra}
        </div>
        <div className={`px-[22px] py-[18px] ${bodyClassName ?? ''}`.trim()}>{children}</div>
    </div>
);

export default SectionCard;
